/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import cx from 'classnames';

class SummaryView extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  render() {
    const { translate } = this.props;

    return (
      <table className="summar_view summary_item_table small">
        <colgroup>
          <col style={{ width: '25%' }} />
          <col style={{ width: '1px' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '18%' }} />
          <col style={{ width: '18%' }} />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.violated_policy')}</p>
                <p
                  className={cx('value', {
                    orange: this.props.file.policyCount.total.detected !== 0,
                  })}
                >
                  {this.props.file.policyCount.total.detected}
                </p>
              </div>
            </td>
            <td>
              <div className="bg_stick" />
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.component')}</p>
                <p className="value small">
                  {this.props.file.policyCount.component.detected === 0 ? (
                    <span>
                      {this.abbreviateNumber(this.props.file.policyCount.component.detected)}
                    </span>
                  ) : (
                    <span style={{ color: '#ffc259' }}>
                      {this.abbreviateNumber(this.props.file.policyCount.component.detected)}
                    </span>
                  )}
                </p>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.security_risk')}</p>
                <p className="value small">
                  {this.props.file.policyCount.security.detected === 0 ? (
                    <span>
                      {this.abbreviateNumber(this.props.file.policyCount.security.detected)}
                    </span>
                  ) : (
                    <span style={{ color: '#ffc259' }}>
                      {this.abbreviateNumber(this.props.file.policyCount.security.detected)}
                    </span>
                  )}
                </p>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.license')}</p>
                <p className="value small">
                  {this.props.file.policyCount.license.detected === 0 ? (
                    <span>
                      {this.abbreviateNumber(this.props.file.policyCount.license.detected)}
                    </span>
                  ) : (
                    <span style={{ color: '#ffc259' }}>
                      {this.abbreviateNumber(this.props.file.policyCount.license.detected)}
                    </span>
                  )}
                </p>
              </div>
            </td>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.litigator')}</p>
                <p className="value small">
                  {this.props.file.policyCount.litigator.detected === 0 ? (
                    <span>
                      {this.abbreviateNumber(this.props.file.policyCount.litigator.detected)}
                    </span>
                  ) : (
                    <span style={{ color: '#ffc259' }}>
                      {this.abbreviateNumber(this.props.file.policyCount.litigator.detected)}
                    </span>
                  )}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
export default SummaryView;
